import { render, staticRenderFns } from "./DiscernmentClothing.vue?vue&type=template&id=796ff38e&scoped=true"
import script from "./DiscernmentClothing.vue?vue&type=script&lang=js"
export * from "./DiscernmentClothing.vue?vue&type=script&lang=js"
import style0 from "./DiscernmentClothing.vue?vue&type=style&index=0&id=796ff38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ff38e",
  null
  
)

export default component.exports